import React from "react";
import { FormFields } from "components/form-fields";
import { CustomPicker } from "react-color";
import { Saturation, Hue, Checkboard, EditableInput } from "react-color/lib/components/common";
import classNames from "classnames";
import PropTypes from "prop-types";
import "./FormFields.css";

const DefaultColourPicker = CustomPicker(function DefaultColourPickerBase({ hex, hsl, hsv, onChange }) {
    return (
        <div className="form-colour-picker-root">
            <div className="form-colour-picker-main-area">
                <div className="form-colour-picker-saturation-wrapper">
                    <Checkboard />
                    <div className="form-colour-picker-saturation-overlay">
                        <Saturation
                            hsl={hsl}
                            hsv={hsv}
                            onChange={onChange}
                            pointer={props => (
                                <div
                                    style={{
                                        width: 16,
                                        height: 16,
                                        borderRadius: '50%',
                                        boxShadow: '0 0 0 1px #d4d4d4',
                                        position: 'absolute',
                                        left: `${props.left}px`,
                                        top: `${props.top}px`,
                                        transform: 'translate(-11px, -11px)',
                                        zIndex: 3,
                                        pointerEvents: 'none',
                                    }}
                                />
                            )}
                        />
                    </div>
                </div>
            </div>
            <div className="form-colour-picker-hue-slider">
                <Hue
                    hsl={hsl}
                    onChange={onChange}
                    pointer={() => (
                        <div className="form-colour-picker-hue-pointer" />
                    )}
                />
            </div>
            <div className="form-colour-picker-bottom-row">
                <div
                    className="form-colour-picker-swatch"
                    style={{ background: hex }}
                />
                <div className="form-colour-picker-input-wrapper">
                    <EditableInput
                        label={null}
                        value={hex}
                        onChange={v => onChange({ hex: v })}
                        style={{
                            input: {
                                width: "100%",
                                minWidth: 80,
                                fontSize: 18,
                                borderRadius: 3,
                                border: 0,
                                padding: "6px 12px",
                                boxShadow: "0 0 0 1px #d4d4d4",
                                textAlign: "center",
                                background: "#fafbfc"
                            }
                        }}
                    />
                </div>
            </div>
        </div>
    );
});

const defaultHelperText = <></>;

export function FormColourPicker({ isLoading = false, isDisabled = false, value, onChange, headingText = "", helperText = defaultHelperText, dangerHelperText = "" }) {
    const handleChange = (color) => {
        onChange(color.hex);
    };

    return (
        <FormFields
            isLoading={isLoading}
            headingText={headingText}
            helperText={helperText}
            dangerHelperText={dangerHelperText}
        >
            <div className={classNames({ "colour-picker-disabled": isDisabled, "bp6-skeleton": isLoading })}>
                <DefaultColourPicker
                    color={value}
                    onChange={handleChange}
                />
            </div>

        </FormFields>
    );
}

FormColourPicker.propTypes = {
    isLoading: PropTypes.bool,
    isDisabled: PropTypes.bool,
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    headingText: PropTypes.string,
    helperText: PropTypes.node,
    dangerHelperText: PropTypes.string,
}